/**
 * Central route table. Every page path is declared here once so links, the
 * router, and navigation items all reference the same source of truth.
 * Manual/editor/approvals routes are parameterised in their feature modules.
 */
export const ROUTES = {
  login: "/login",
  home: "/",
  approvals: "/approvals",
  search: "/search",
  settingsAccess: "/settings/access",
} as const;

export type RouteKey = keyof typeof ROUTES;
